import { render } from "./FDFooterUnderline.vue?vue&type=template&id=5a15a874"
import script from "./FDFooterUnderline.vue?vue&type=script&lang=js"
export * from "./FDFooterUnderline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__